// 📝 설문 상단 배너 (2026-09-11 사용자 "상단에 업데이트처럼 임시 버튼 하나") — UpdaterBanner 와 같은 자리·모양(상단 중앙 pill).
//   서버가 visible(공개 범위·켜짐)과 answered 를 판정해 준다 — 응답 완료자·범위 밖 사용자에겐 렌더 없음.
//   '나중에' 는 이 세션(탭)에서만 숨김(sessionStorage) — 다음 실행에 다시 보인다(임시 설문이라 강하게 노출).
//   모바일(<768)은 상단 탭과 겹치지 않게 우하단으로 내린다.
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { useSurveyState } from '../../api/survey';
import SurveyModal from './SurveyModal';
import { Icon } from '../icons';

const DISMISS_KEY = 'tpt-survey-dismissed';

export default function SurveyBanner() {
	const { t } = useTranslation();
	const loc = useLocation();
	const st = useSurveyState();
	const [open, setOpen] = useState(false);
	const [dismissed, setDismissed] = useState(() => { try { return sessionStorage.getItem(DISMISS_KEY) === '1'; } catch { return false; } });
	const onApp = loc.pathname.startsWith('/chat') || loc.pathname.startsWith('/projects') || loc.pathname.startsWith('/feeds') || loc.pathname.startsWith('/drive');
	if (!st || !st.visible || st.answered || !onApp) return null;
	if (dismissed && !open) return null;
	return (
		<>
			<div className="fixed z-[1900] max-md:bottom-24 max-md:right-3 md:top-1.5 md:left-1/2 md:-translate-x-1/2" data-testid="survey-banner">
				<div className="flex items-center gap-1 rounded-full bg-class-blue px-1 py-0.5 text-white shadow-lg ring-2 ring-white/70">
					<button type="button" onClick={() => setOpen(true)} title={t('survey.bannerTitle')} data-testid="survey-banner-open"
						className="flex items-center gap-1.5 rounded-full px-2.5 py-1 text-ui-xs font-bold hover:bg-white/15">
						<Icon name="file-text" size={12} /><span>{t('survey.banner')}</span>
						{/* 📅 남은 기간 — 마감이 정해진 회차만. 당일이면 '오늘까지'(2026-09-13 사용자 "설문기간이 없네") */}
						{st.daysLeft !== null && st.daysLeft !== undefined && (
							<span className="rounded-full bg-white/25 px-1.5 py-px text-[10px] font-bold" data-testid="survey-banner-dday">
								{st.daysLeft <= 0 ? t('survey.ddayToday') : t('survey.dday', { n: st.daysLeft })}
							</span>
						)}
					</button>
					<button type="button" onClick={() => { try { sessionStorage.setItem(DISMISS_KEY, '1'); } catch { /* */ } setDismissed(true); }} title={t('survey.later')}
						className="rounded-full px-1.5 py-1 text-ui-xs text-white/80 hover:bg-white/15">✕</button>
				</div>
			</div>
			{open && <SurveyModal open onClose={() => setOpen(false)} />}
		</>
	);
}
